export default __webpack_public_path__ + "static/media/6-cheese.480958e7.png";